import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { ObjectCard } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { useNavigate } from '~/lib/navigation';
import { Card, CardRepository } from '~/repositories/CardRepository';
import { useSessionStore } from '~/stores/Session';

interface CardCardProps {
  cardId: string;
}

const getCardName = (card?: Card) => {
  if (!card) return undefined;
  return `Card ****${card.lastFourDigits}`;
};

export const CardCard: React.FC<CardCardProps> = ({ cardId }) => {
  const navigate = useNavigate();
  const { currentPlatform } = useSessionStore();

  const {
    data: card,
    isLoading,
    error,
  } = useQuery<Card>({
    queryKey: [currentPlatform?.id, 'card', cardId],
    queryFn: async () => CardRepository.get(cardId),
    enabled: !!cardId,
    gcTime: 30000,
    staleTime: 10000,
  });

  const handleNavigate = () => {
    navigate(`${ROUTE.CARDS}/edit/${cardId}`);
  };

  return (
    <ObjectCard
      error={error ? 'Failed to load card' : undefined}
      isLoading={isLoading}
      primaryText={getCardName(card) || 'Card'}
      id={{ label: 'ID:', value: cardId }}
      onClick={handleNavigate}
    />
  );
};
